import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import LogRocket from 'logrocket';
import { IUser } from '../contracts/user.contract';
import { UserService } from '../services';

interface IInitialState {
    CurrentUser: IUser | undefined;
    IsLoading: boolean;
    ErrorMessage: string | undefined;
}

const initialState: IInitialState = {
    CurrentUser: undefined,
    IsLoading: false,
    ErrorMessage: undefined
};

const Fetch = {
    GetCurrentUser: createAsyncThunk('user/GetCurrentUser', async (_, { rejectWithValue }) => {
        try {
            const res = await UserService.getCurrentUser();
            return res;
        } catch (err) {
            return rejectWithValue(err);
        }
    })
};

const UserSlice = createSlice({
    name: 'user',
    initialState: initialState,
    reducers: {
        SetErrorMessage: (state, action: PayloadAction<string | undefined>) => {
            state.ErrorMessage = action.payload;
        }
    },
    extraReducers: (builder) => {
        // GetCurrentuser
        builder.addCase(UserFetch.GetCurrentUser.pending, (state, action) => {
            state.IsLoading = true;
            state.ErrorMessage = undefined;
        });
        builder.addCase(UserFetch.GetCurrentUser.fulfilled, (state, action: PayloadAction<IUser>) => {
            const user = action.payload;
            state.CurrentUser = user;
            state.IsLoading = false;
            state.ErrorMessage = undefined;

            // Log Rocket User
            if (user) {
                LogRocket.identify(user.Email, {
                    name: `${user.FirstName} ${user.LastName}`,
                    email: user.Email,
                    userName: user.UserName
                });
            }
        });
        builder.addCase(UserFetch.GetCurrentUser.rejected, (state, action) => {
            state.CurrentUser = undefined;
            state.IsLoading = false;
            state.ErrorMessage = action.payload?.toString();
        });
    }
});

export const UserFetch = Fetch;
export const UserAction = UserSlice.actions;
export const UserReducer = UserSlice.reducer;
